import axios from 'axios';
import { isJwtExpired } from '../auth/jwt/tokenUtils';

// Create axios instance
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
    (config) => {
        // Add auth token
        const authData = localStorage.getItem('adminAuth');
        if (authData) {
            try {
                const { token } = JSON.parse(authData);
                if (token) {
                    if (isJwtExpired(token)) {
                        localStorage.removeItem('adminAuth');
                        if (window.location.pathname !== '/login') {
                            window.location.href = '/login';
                        }
                        return Promise.reject(new Error('Session expired'));
                    }
                    config.headers.Authorization = `Bearer ${token}`;
                }
            } catch (error) {
                console.error('Error parsing auth data:', error);
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for error handling
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Unauthorized - clear auth and redirect to login
            localStorage.removeItem('adminAuth');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
